export const models = [
  { value: "MAN", label: "MAN" },
  { value: "DAF", label: "DAF" },
  { value: "Volvo Trucks", label: "Volvo Trucks" },
  { value: "Scania", label: "Scania" },
  { value: "Mercedes Benz", label: "Mercedes Benz" },
  { value: "Renault Trucks", label: "Renault Trucks" },
  { value: "Iveco", label: "RenIveco" },
  { value: "Freightliner", label: "Freightliner" },
];

export const orderTypes = [
  { value: 1, label: "Оборудование" },
  { value: 2, label: "Стройматериалы" },
  { value: 3, label: "Металл" },
  { value: 4, label: "Продукты" },
  { value: 5, label: "Запчасти" },
  { value: 6, label: "Сырьё" },
  { value: 7, label: "Мебель" },
  { value: 8, label: "Металлопрокат" },
  { value: 9, label: "Трубы" },
];

export const trailers = [
  {
    value: "Schmitz Cargobull",
    label: "Schmitz Cargobull",
  },
  {
    value: "Chereau",
    label: "Chereau",
  },
  {
    value: "Krone",
    label: "Krone",
  },
  {
    value: "Wielton",
    label: "Wielton",
  },
  {
    value: "ЦТТМ",
    label: "ЦТТМ",
  },
  {
    value: "Grunwald",
    label: "Grunwald",
  },
  {
    value: "ТСП, Политранс",
    label: "ТСП, Политранс",
  },
  {
    value: "АПС",
    label: "АПС",
  },
  {
    value: "Koegel",
    label: "Koegel",
  },
  {
    value: "Pacton",
    label: "Pacton",
  },
  {
    value: "Fliegl",
    label: "Fliegl",
  },
  {
    value: "Lamberet",
    label: "Lamberet",
  },
  {
    value: "Schwarzmüller",
    label: "Schwarzmüller",
  },
  {
    value: "Kel-Berg",
    label: "Kel-Berg",
  },
  {
    value: "Broshuis",
    label: "Broshuis",
  },
  {
    value: "МАЗ",
    label: "МАЗ",
  },
  {
    value: "Steelbear",
    label: "Steelbear",
  },
  {
    value: "Baryval",
    label: "Baryval",
  },
  {
    value: "Kässbohrer",
    label: "Kässbohrer",
  },
  {
    value: "Тонар",
    label: "Тонар",
  },
  {
    value: "Samro",
    label: "Samro",
  },
  {
    value: "Fruehauf",
    label: "Fruehauf",
  },
  {
    value: "LeciTrailer",
    label: "LeciTrailer",
  },
  {
    value: "ALI RIZA USTA",
    label: "ALI RIZA USTA",
  },
  {
    value: "Nursan Trailer",
    label: "Nursan Trailer",
  },
  {
    value: "Bodex",
    label: "Bodex",
  },
  {
    value: "STOKOTA",
    label: "STOKOTA",
  },
  {
    value: "ZASLAW",
    label: "ZASLAW",
  },
  {
    value: "MONTRACON",
    label: "MONTRACON",
  },
];

export const loadTypes = [
  { value: 1, label: "Верхняя загрузка" },
  { value: 2, label: "Боковая загрузка" },
  { value: 3, label: "Задняя загрузка" },
  { value: 4, label: "С полной растентовкой" },
];

export const currencies = [
  { label: "KGS", value: 4 },
  { label: "RUB", value: 2 },
  { label: "USD", value: 1 },
  { label: "KZT", value: 3 },
  { label: "KGS", value: 0 },
];

export const shippingTypes = [
  { value: 1, label: "FTL (Отдельный транспорт)" },
  { value: 2, label: "LTL (догруз)" },
  { value: 3, label: "Проект, негабарит" },
];

export const shippingTypesCls = {
  1: "ftl",
  2: "ltl",
  3: "project",
};

export const additionalLoadTypes = [
  { value: 1, label: "Полная погрузка" },
  { value: 2, label: "Догруз" },
];

export const packageTypes = [
  { value: 1, label: "EUR-палеты" },
  { value: 2, label: "FIN-палеты" },
  { value: 3, label: "Особые палеты" },
  { value: 4, label: "Коробки" },
  { value: 5, label: "Контейнер" },
  { value: 6, label: "Без упаковки" },
];

export const additionalOptions = [
  { value: 1, label: "Пирамида / Стойки / Коники" },
  { value: 2, label: "Мега (низкорамник)" },
  { value: 3, label: "Допельшток (два яруса)" },
  { value: 4, label: "Телескопический подъемник" },
  { value: 5, label: "Желоб для рулонов" },
  { value: 6, label: "Мультитемпературный" },
  { value: 7, label: "Кран" },
  { value: 8, label: "Подвижный пол" },
  { value: 9, label: "Гидроманипулятор" },
  { value: 10, label: "Гидроборт" },
  { value: 11, label: "Аппарели / Трапы" },
  { value: 12, label: "Мультилифт (контейнерный)" },
  { value: 13, label: "Погрузочные работы" },
  { value: 14, label: "Разгрузочные работы" },
];

export const currency = (type) => {
  if (!type) {
    return "";
  }
  const currency = currencies.find((c) => c.value == type);
  return currency.label;
};

export const shippingType = (type) => {
  if (!type) {
    return "";
  }
  const shippingType = shippingTypes.find((c) => c.value == type);
  return shippingType.label;
};

export const loadType = (type) => {
  if (!type) {
    return "";
  }
  const transportType = loadTypes.find((t) => t.value == type);
  return transportType.label;
};

export const orderType = (type) => {
  if (!type) {
    return "";
  }
  const orderType = orderTypes.find((c) => +c.value == +type);
  if (!orderType) {
    return "";
  }
  return orderType.label;
};

export const packageType = (type) => {
  if (!type) {
    return "";
  }
  const packageType = packageTypes.find((c) => +c.value == +type);
  if (!packageType) {
    return null;
  }
  return packageType.label;
};

export const additionalOption = (type) => {
  if (!type) {
    return "";
  }
  const option = additionalOptions.find((c) => c.value == type);
  if (!option) {
    return null;
  }
  return option.label;
};
